<template>
  <div id="mainBox">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="flex search-box">
      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">鉴别号：</span>
        <div style="width: 180px">
          <el-input v-model="query.inspectionNo" placeholder="请输入鉴别号" clearable @keyup.enter.native="searchFn" />
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">订单号：</span>
        <div style="width: 180px">
          <el-input v-model="query.orderNo" placeholder="请输入订单编号" clearable @keyup.enter.native="searchFn" />
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">时间：</span>
        <div style="width: 290px">
          <el-date-picker v-model="query.timeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" />
        </div>
      </div>
    </div>

    <div class="operate-btns">
      <el-button type="success" size="medium" @click="searchFn">搜索</el-button>
      <el-button size="medium" @click="resetFn">重置</el-button>
      <el-button type="primary" size="medium" @click="copyAllAddresses">复制所有地址</el-button>
    </div>

    <el-table class="data-table" :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading"
      @selection-change="handleSelectionChange">
      <el-table-column prop="inspectionNo" width="150" align="center" label="鉴别号" />
      <el-table-column prop="shelfNo" width="120" align="center" label="货架号">
        <template slot-scope="scope">
          <span v-if="scope.row.shelfNo">{{ scope.row.shelfNo }}</span>
          <span v-else style="color: #999">未绑定</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderNo" width="150" align="center" label="订单编号" />
      <el-table-column prop="orderType" width="120" align="center" label="订单类型">
        <template slot-scope="scope">{{ getOrderTypeText(scope.row.orderType) }}</template>
      </el-table-column>
      <el-table-column label="商品信息" min-width="220" align="center">
        <template slot-scope="scope">
          <div style="line-height: 1.6; text-align: left">
            <div v-if="scope.row.productTitle">{{ scope.row.productTitle }}</div>
            <div v-if="brandDisplay(scope.row)">品牌：{{ brandDisplay(scope.row) }}</div>
            <div v-if="typeDisplay(scope.row)">型号：{{ typeDisplay(scope.row) }}</div>
            <div v-if="scope.row.batchNum">批次号：{{ scope.row.batchNum }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="receiverName" width="120" align="center" label="收货人" />
      <el-table-column prop="receiverPhone" width="130" align="center" label="联系电话" />
      <el-table-column prop="receiverAddress" min-width="200" align="center" label="收货地址" />
      <el-table-column prop="createTime" width="160" align="center" label="创建时间">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column min-width="200" align="left" label="操作" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex; flex-wrap: wrap; gap: 6px; justify-content: flex-start;">
            <el-button type="primary" size="small" @click="showDetailDialog(scope.row)">详情</el-button>
            <el-button type="success" size="small" @click="confirmDelivery(scope.row)">确认发货</el-button>
            <el-button type="info" size="small" @click="copyAddress(scope.row)">复制地址</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 详情弹窗 -->
    <el-dialog title="鉴别作业详情" :visible.sync="detailDialogVisible" width="1000px" :close-on-click-modal="false"
      @closed="onDetailDialogClosed" style="max-height: 95vh; overflow: hidden;">
      <div style="height: calc(95vh - 220px); overflow-y: auto;">
        <InspectionJobDetail v-if="detailJobId" :job-id="detailJobId" />
      </div>
    </el-dialog>

    <!-- 确认发货弹窗 -->
    <el-dialog title="确认发货" :visible.sync="shipToBuyerVisible" width="520px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="鉴别号">
          <div>{{ shipToBuyerForm.inspectionNo }}</div>
        </el-form-item>
        <el-form-item label="收货人">
          <div>{{ shipToBuyerForm.receiverName }}</div>
        </el-form-item>
        <el-form-item label="联系电话">
          <div>{{ shipToBuyerForm.receiverPhone }}</div>
        </el-form-item>
        <el-form-item label="收货地址">
          <div>{{ shipToBuyerForm.receiverAddress }}</div>
        </el-form-item>
        <el-form-item label="物流公司" required>
          <el-select v-model="shipToBuyerForm.expressCompany" placeholder="请选择物流公司" filterable style="width: 100%">
            <el-option v-for="item in companyData" :key="item.code" :label="item.title" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" required>
          <el-input v-model="shipToBuyerForm.expressNo" placeholder="请填写物流单号" maxlength="60" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shipToBuyerVisible = false">取消</el-button>
        <el-button type="success" :loading="shipToBuyerLoading" @click="submitShipToBuyer">确认发货</el-button>
      </span>
    </el-dialog>

    <div class="page_box">
      <el-pagination @current-change="changePage" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next,jumper" :total="tableTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import historyTag from "@/components/historyTag";
import InspectionJobDetail from "./detail.vue";
import expressInfo from "@/util/expressInfo";
import { api } from "@/util/requestUrl";
import {
  buildDefaultTimeRange,
  resolveCreateTimeRange,
} from "@/util/inspectionJobTimeRange";

export default {
  components: {
    historyTag,
    InspectionJobDetail,
  },
  data() {
    return {
      historyArr: ["鉴别作业", "待发货列表"],
      tableData: [],
      currentPage: 1,
      pageSize: 8,
      tableTotal: 0,
      selectedRows: [],
      loading: false,

      detailDialogVisible: false,
      detailJobId: null,

      shipToBuyerVisible: false,
      shipToBuyerLoading: false,
      companyData: expressInfo.arr || [],
      shipToBuyerForm: {
        id: null,
        orderId: null,
        orderNo: "",
        inspectionNo: "",
        orderType: null,
        pendingDeliveryScene: "",
        relatedTradeOrderId: null,
        receiverName: "",
        receiverPhone: "",
        receiverAddress: "",
        expressCompany: "",
        expressNo: "",
      },

      query: {
        timeRange: buildDefaultTimeRange(),
        inspectionNo: "",
        orderNo: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        inspectionNo: this.query.inspectionNo || null,
        orderNo: this.query.orderNo || null,
      };

      Object.assign(params, resolveCreateTimeRange(this.query.timeRange));

      this.loading = true;
      this.$axios
        .post(api.selPlatformWaitingDeliveryList, params)
        .then((res) => {
          this.loading = false;
          if (res.data.code === 200) {
            this.tableData = res.data.data.records || [];
            this.tableTotal = res.data.data.total || 0;
          } else {
            this.$message.error(res.data.msg || "获取列表失败");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("网络异常");
        });
    },

    searchFn() {
      this.currentPage = 1;
      this.getList();
    },

    resetFn() {
      this.query = {
        timeRange: null,
        inspectionNo: "",
        orderNo: "",
      };
      this.currentPage = 1;
      this.getList();
    },

    changePage(page) {
      this.currentPage = page;
      this.getList();
    },

    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },

    showDetailDialog(row) {
      this.detailJobId = row.id;
      this.detailDialogVisible = true;
    },

    onDetailDialogClosed() {
      this.detailJobId = null;
    },

    confirmDelivery(row) {
      this.shipToBuyerForm = {
        id: row.id,
        orderId: row.orderId,
        orderNo: row.orderNo || "",
        inspectionNo: row.inspectionNo || "",
        orderType: row.orderType,
        pendingDeliveryScene: row.pendingDeliveryScene || "",
        relatedTradeOrderId: row.relatedTradeOrderId || null,
        receiverName: row.receiverName || "",
        receiverPhone: row.receiverPhone || "",
        receiverAddress: row.receiverAddress || "",
        expressCompany: "",
        expressNo: "",
      };
      this.shipToBuyerVisible = true;
    },

    submitShipToBuyer() {
      const f = this.shipToBuyerForm || {};
      const company = (f.expressCompany || "").trim();
      if (!company) {
        this.$message.error("请选择物流公司");
        return;
      }
      const no = (f.expressNo || "").trim();
      if (!no) {
        this.$message.error("请填写物流单号");
        return;
      }
      this.shipToBuyerLoading = true;

      const scene = f.pendingDeliveryScene || "";
      let requestData;
      let requestUrl;

      if (scene === "consignment_sold") {
        if (!f.relatedTradeOrderId) {
          this.shipToBuyerLoading = false;
          this.$message.error("缺少关联成交单，无法发货");
          return;
        }
        requestUrl = api.updateSecondhandOrder;
        requestData = {
          id: f.relatedTradeOrderId,
          status: 2,
          logisticsCompany: company,
          logisticsNo: no,
        };
      } else if (scene === "safe_buy_to_buyer") {
        if (!f.orderId) {
          this.shipToBuyerLoading = false;
          this.$message.error("缺少订单ID");
          return;
        }
        requestUrl = api.centerShipToBuyerAfterConfirm;
        requestData = {
          orderId: f.orderId,
          expressCompany: company,
          expressNo: no,
        };
      } else if (scene === "safe_buy_to_seller") {
        if (!f.orderId) {
          this.shipToBuyerLoading = false;
          this.$message.error("缺少订单ID");
          return;
        }
        requestUrl = api.centerShipBackToSeller;
        requestData = {
          orderId: f.orderId,
          expressCompany: company,
          expressNo: no,
        };
      } else if ([1, 2].includes(f.orderType)) {
        if (!f.orderId) {
          this.shipToBuyerLoading = false;
          this.$message.error("缺少订单ID");
          return;
        }
        requestUrl = api.upOrder;
        requestData = {
          id: f.orderId,
          status: 4,
          hxinfo: JSON.stringify({
            code: company,
            phone: f.receiverPhone || "",
            title: company,
            num: no,
          }),
        };
      } else {
        this.shipToBuyerLoading = false;
        this.$message.error("未知发货场景");
        return;
      }

      this.$axios
        .post(requestUrl, requestData)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("已确认发货");
            this.shipToBuyerVisible = false;
            this.getList();
          } else {
            this.$message.error(res.data.msg || "操作失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.shipToBuyerLoading = false;
        });
    },

    copyAddress(row) {
      const address = `${row.receiverName} ${row.receiverPhone} ${row.receiverAddress}（${row.shelfNo || "-"}）`;
      this.copyToClipboard(address);
      this.$message.success("地址已复制");
    },

    copyAllAddresses() {
      const params = {
        inspectionNo: this.query.inspectionNo || null,
        orderNo: this.query.orderNo || null,
      };
      Object.assign(params, resolveCreateTimeRange(this.query.timeRange));
      this.$axios
        .post(api.getAllPlatformDeliveryAddresses, params)
        .then((res) => {
          if (res.data.code === 200) {
            const addresses = res.data.data;
            if (addresses) {
              this.copyToClipboard(addresses);
              this.$message.success("所有地址已复制");
            } else {
              this.$message.warning("没有待发货地址");
            }
          } else {
            this.$message.error(res.data.msg || "获取地址失败");
          }
        })
        .catch((err) => {
          this.$message.error("网络异常");
        });
    },

    copyToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },

    getOrderTypeText(type) {
      const types = {
        1: "寄售订单",
        2: "鉴别订单",
        3: "二手订单",
        4: "安心购订单",
      };
      return types[type] || "未知";
    },

    brandDisplay(row) {
      if (!row) return "";
      const cn = row.brandName || "";
      const en = row.brandEnglishName || "";
      if (cn && en) return cn + " - " + en;
      return cn || en || "";
    },

    typeDisplay(row) {
      if (!row) return "";
      const cn = row.typeName || "";
      const en = row.typeEnglishName || "";
      if (cn && en) return cn + " - " + en;
      return cn || en || "";
    },

    formatTime(time) {
      if (!time) return "-";
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>

<style scoped>
.historyTag {
  width: 100%;
  box-sizing: border-box;
}

#mainBox {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.search-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 0;
  row-gap: 8px;
  column-gap: 12px;
}

.search-item {
  display: flex;
  align-items: center;
}

.operate-btns {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 20px;
  gap: 10px;
}

.data-table {
  padding: 0 20px;
}

.page_box {
  margin: 20px;
  text-align: right;
}

.btnLi {
  margin: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/inspectionJob/deliveryList.vue